import { render } from "./UsersDrawer.vue?vue&type=template&id=aa1073be&scoped=true"
import script from "./UsersDrawer.vue?vue&type=script&lang=js"
export * from "./UsersDrawer.vue?vue&type=script&lang=js"

import "./UsersDrawer.vue?vue&type=style&index=0&id=aa1073be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1073be"]])

export default __exports__